import { IOrderDiscount } from './order-discount.interface';
import { IOrderSummaryLineItem } from './order-summary-line-item.interface';

export interface IOrderSummary {
  orderNumber: string;
  orderDate: string;
  orderLines: IOrderSummaryLineItem[];
  orderSubtotal: number;
  orderTotal: number;
  membershipNumber: string;
  discount?: IOrderDiscount
}
